import { render, staticRenderFns } from "./ProductRow.vue?vue&type=template&id=f5a74fd8&slot=items&"
import script from "./ProductRow.vue?vue&type=script&lang=js&"
export * from "./ProductRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/tonyj/Documents/Proyectos/lastedchange/transit-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VChip,VIcon,VSelect})
